<template>
    <div>
        
        <table class="table" v-if="data">
            <thead>
                <tr>
                    <th>Bulan</th>
                    <!-- <th>Target Sales</th> -->
                    <th>No. Of Sales</th>
                    <!-- <th>Difference</th> -->
                    <!-- <th>Status</th> -->
                </tr>
            </thead>
            <tbody class="detailStockTable">
                <tr v-for="dat in data">
                    <td>{{ monthNames[dat.month-1] }}</td>
                    <!-- <td>{{ numberWithCommas(dat.target) }}</td> -->
                    <td>{{ numberWithCommas(dat.sales) }}</td>
                    <!-- <td>{{ dat.diff }}</td> -->
                    <!-- <td>{{ dat.status }}</td> -->
                </tr>
            </tbody>
        </table>

        <div style="min-height: 400px; display: flex; align-items: center; justify-content: center;" v-else>
            <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
        </div>

    </div>
</template>

<script>
    export default {
        data () {
            return {
                dummyData : null,
                monthNames : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            }
        },
        props : ['data'],
        mounted () {
            // this.generateDummyData();
        },
        methods : {
            generateDummyData () {
                let dummy = [];

                let monthNames = ['January', 'February', 'March', 'April', 'May', 'June']
                for (var i = 0; i < monthNames.length; i++) {
                    let target = this.randomInt(5000, 8000);
                    let sales = this.randomInt(5000, 8000);

                    let singleDummy = {
                        month : monthNames[i],
                        target : target,
                        sales : sales,
                        diff : `${sales-target < 0 ? '-' : '+'} ${this.numberWithCommas(Math.abs(sales-target))}`,
                        status : sales-target < 0 ? 'Unachieved' : 'Achieved'
                    }
                    dummy.push(singleDummy);
                }

                this.dummyData = dummy;
            },
        }
    }
</script>

<style scoped>
    /* Uncomment if table wants to be scrollable */
    /* tbody {
        display: block;
        height: 400px;
        overflow-y: scroll;
    }

    thead, tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    thead {
        width: calc(100% - 10px);
    } */

    table {
        text-align: center;
    }

    thead tr th {
        border-bottom: 0.5px solid #FF0009;
        font: normal normal 500 14px/16px Ubuntu;
        color: #707070;
    }

    tbody tr td {
        font: normal normal 500 13px/14px Ubuntu;
        color: #707070;
    }

    thead tr th,
    tbody tr td {
        vertical-align: middle;
    }

    .detailStockTable::-webkit-scrollbar{
        width:10px;
    }
    .detailStockTable::-webkit-scrollbar-track{
        background-color: white;
        border-radius: 20px;
    }
    .detailStockTable::-webkit-scrollbar-thumb{
        background-color: #F1F1F1;
        border-radius: 20px;
    }
</style>